<template>
    <div class="input-container">
        <label v-if="label" :for="name" class="input-label">{{ label }}</label>
        <div class="number-input">
            <button @click="decreaseValue" class="btn minus">-</button>

            <input :id="name" :name="name" :placeholder="placeholder" :step="step" :value="formattedValue"
                @input="updateValue($event.target.value)" @blur="formatValue" type="text" class="input-field" />

            <button @click="increaseValue" class="btn plus">+</button>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        name: {
            type: String,
            require: true
        },
        label: {
            type: String,
            default: "",
        },
        placeholder: {
            type: String,
            default: "Enter a number",
        },
        value: Number,
        step: Number
    },
    computed: {
        formattedValue() {
            return new Intl.NumberFormat('en-US').format(this.localValue);
        },
    },
    data() {
        return {
            showButton: true,
            localValue: this.value
        };
    },
    methods: {
        updateValue(value) {
            const numericValue = parseFloat(value.replace(/[^0-9.-]+/g, ''));
            this.localValue = isNaN(numericValue) ? 0 : numericValue;
            this.emitValue();
        },
        formatValue() {
            this.localValue = parseFloat(this.localValue.toFixed(2));
            this.emitValue();
        },
        increaseValue() {
            this.localValue += this.step;
            this.emitValue();
        },
        decreaseValue() {
            if (this.localValue > 0) {
                this.localValue -= this.step;
            }
            this.emitValue();
        },
        emitValue() {
            this.$emit('change', {'name': this.name, 'value': this.localValue});
        }
    },
};
</script>

<style scoped>
.input-container {
  position: relative;
  display: inline-block;
  margin: 20px 0;
}

.input-label {
  position: absolute;
  top: -10px;
  left: 25%;
  transform: translateX(-50%);
  background-color: white; /* Match the background of the input */
  padding: 0 5px;
  font-size: 14px;
  color: #666;
}

.number-input {
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #ccc;
    border-radius: 4px;
    width: fit-content;
    padding: 5px;
    background-color: #f9f9f9;
}

/* Button styles */
.btn {
    width: 20px;
    height: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 16px;
    border: none;
    background-color: var(--gray);
    color: white;
    cursor: pointer;
}

.btn.minus {
    border-radius: 3px 0 0 3px;
    /* Rounded corners for the minus button */
}

.btn.plus {
    border-radius: 0 3px 3px 0;
    /* Rounded corners for the plus button */
}

.btn:hover {
    background-color: var(--green);
    /* Darker blue on hover */
}

/* Input field styles */
.input-field {
    width: 120px;
    text-align: center;
    border: none;
    font-size: 18px;
    padding: 5px;
    outline: none;
    -moz-appearance: textfield;
}

/* Remove input field arrows in number input */
.input-field::-webkit-outer-spin-button,
.input-field::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}
</style>